export var ErrorMessage;
(function (ErrorMessage) {
    ErrorMessage["ImageRemovedDuringLoad"] = "Image was removed while loading";
    ErrorMessage["ImageLoadingFailed"] = "Could not load image";
    ErrorMessage["ResizeObservableLoopLimit"] = "ResizeObserver loop limit exceeded";
    ErrorMessage["ResizeObservableLoopCompleted"] = "ResizeObserver loop completed with undelivered notifications";
})(ErrorMessage || (ErrorMessage = {}));
